export default "__VITE_ASSET__D$Gu79zX__"